const TagListColumn = [
  {
    title: 'No.',
    dataIndex: 'index',
    sorter: (a, b) => a.index - b.index,
    width: 100
  },
  {
    title: 'Tag Name',
    dataIndex: 'name',
    sorter: (a, b) => a.name.localeCompare(b.name),
    width: 300
  },
  {
    title: 'URL Count',
    dataIndex: 'urlCount',
    sorter: (a, b) => (a.urlCount || 0) - (b.urlCount || 0),
    width: 150
  },
  {
    title: '',
    dataIndex: '',
    slot: 'operation',
    width: 50
  }
];

export { TagListColumn };
